<script lang="ts" setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
})

const config = useRuntimeConfig()

const route = useRoute()

const networks = [
  {
    name: 'facebook',
    icon: 'mdi:facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${config.public.siteUrl}${route.fullPath}`,
  },
  {
    name: 'twitter',
    icon: 'mdi:twitter',
    url: `https://twitter.com/intent/tweet?url=${config.public.siteUrl}${route.fullPath}`,
  },
  {
    name: 'linkedin',
    icon: 'mdi:linkedin',
    url: `https://www.linkedin.com/shareArticle?mini=true&url=${config.public.siteUrl}${route.fullPath}`,
  },
  {
    name: 'whatsapp',
    icon: 'mdi:whatsapp',
    url: `https://api.whatsapp.com/send?text=${config.public.siteUrl}${route.fullPath}`,
  },
  {
    name: 'email',
    icon: 'mdi:email',
    url: `mailto:?subject=${props.title}&body=${config.public.siteUrl}${route.fullPath}`,
  },
]
</script>

<template>
  <div class="social-share-block flex gap-4">
    <div v-for="network in networks" :key="network.name">
      <a
        :href="network.url"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="hover:text-forest-500 text-gray-700"
      >
        <Icon :name="network.icon" :path="network.icon" class="h-6 w-6" />
      </a>
    </div>
  </div>
</template>

<style scoped>
/* Add your custom styles here if needed */
</style>
